// @ts-nocheck
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import MobiusCheckboxGroup, { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup/CheckboxGroup";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC } from "react";
import { useTheme } from "styled-components";

const errorText = "An option needs to be selected.";

const Row: FC<CheckboxProps & { label: string }> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <Checkbox {...props}>{label}</Checkbox>
        </GridItem>
        <GridItem width={4}>
            <Checkbox disabled {...props}>
                {label} (Disabled)
            </Checkbox>
        </GridItem>
        <GridItem width={4}>
            <Checkbox error {...props}>
                {label} (Error)
            </Checkbox>
        </GridItem>
    </>
);

const CheckboxGroup: FC<CheckboxGroupProps> = props => (
    <MobiusCheckboxGroup {...props}>
        <Checkbox>Lorem Ipsum</Checkbox>
        <Checkbox>Lorem Ipsum</Checkbox>
        <Checkbox>Lorem Ipsum</Checkbox>
    </MobiusCheckboxGroup>
);

const GroupRow: FC<CheckboxGroupProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <CheckboxGroup label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <CheckboxGroup label={`${label} (Required)`} required {...props} />
        </GridItem>
        <GridItem width={4}>
            <CheckboxGroup label={`${label} (Error)`} error={errorText} {...props} />
        </GridItem>
    </>
);

const Variant: FC<CheckboxProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <StyleguideSection title={upperFirst(sizeVariant)} variant="h3">
            <GridContainer {...gridContainerProps}>
                <Row label="Default" sizeVariant={sizeVariant} />
                <Row label="Checked" sizeVariant={sizeVariant} checked />
                <Row label="Indeterminate" sizeVariant={sizeVariant} checked="indeterminate" />
                <Row label="Toggle - Right" sizeVariant={sizeVariant} variant="toggle" labelPosition="right" />
                <GridItem width={4}>
                    <Checkbox sizeVariant={sizeVariant}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent mollis commodo tincidunt.
                        Fusce rhoncus condimentum ex, vel consectetur justo tempus et.
                    </Checkbox>
                </GridItem>
                <GridItem width={8} />
                <GridItem width={4}>
                    <Checkbox sizeVariant={sizeVariant} variant="toggle" labelPosition="right">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent mollis commodo tincidunt.
                        Fusce rhoncus condimentum ex, vel consectetur justo tempus et.
                    </Checkbox>
                </GridItem>
                <GridItem width={8} />
                <Row label="Toggle" sizeVariant={sizeVariant} variant="toggle" />
                <Row label="Left" sizeVariant={sizeVariant} labelPosition="left" />
                <GroupRow label="Group" sizeVariant={sizeVariant} />
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideCheckboxes: FC = () => (
    <StyleguideSection title="Checkboxes">
        <Variant sizeVariant="default" />
        <Variant sizeVariant="small" />
    </StyleguideSection>
);

export default StyleguideCheckboxes;
